import React, { useState } from "react";
import Button from "../../components/Button";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import Input from "../../components/Input";

const OTP = () => {
  const [value, setValue] = useState({});
  const handleChange = (e) => {
    setValue({ ...value, [e.target.name]: e.target.value });
  };
  const moveField = (e, last, prev) => {
    if (e.key !== "Backspace") {
      document.getElementById(last)?.focus();
    }
    if (e.code === "Backspace") {
      document.getElementById(prev)?.focus();
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(Object.values(value));
  };
  return (
    <>
      <Header />
      <div className="otp_page_wrapper">
        <div style={{ backgroundColor: "#fff" }} className="otp_card">
          <div className="section_title">
            <h2>Please enter the OTP to verify your account</h2>
            <p>A OTP has been sent to demo@gmail.com</p>
          </div>
          <div className="otp_content">
            <form onSubmit={handleSubmit}>
              <div className="form_group">
                <Input
                  type="text"
                  name="otp1"
                  id="field1"
                  onChange={handleChange}
                  className="otp_input input_field"
                  maxLength="1"
                  onKeyUp={(e) => moveField(e, "field2")}
                />
                <Input
                  type="text"
                  name="otp2"
                  id="field2"
                  onChange={handleChange}
                  className="otp_input input_field"
                  maxLength="1"
                  onKeyUp={(e) => moveField(e, "field3", "field1")}
                />
                <Input
                  type="text"
                  name="otp3"
                  id="field3"
                  onChange={handleChange}
                  className="otp_input input_field"
                  maxLength="1"
                  onKeyUp={(e) => moveField(e, "field4", "field2")}
                />
                <Input
                  type="text"
                  name="otp4"
                  id="field4"
                  onChange={handleChange}
                  className="otp_input input_field"
                  maxLength="1"
                  onKeyUp={(e) => moveField(e, "field5", "field3")}
                />
                <Input
                  type="text"
                  name="otp5"
                  id="field5"
                  onChange={handleChange}
                  className="otp_input input_field"
                  maxLength="1"
                  onKeyUp={(e) => moveField(e, "field6", "field4")}
                />
                <Input
                  type="text"
                  name="otp6"
                  id="field6"
                  onChange={handleChange}
                  className="otp_input input_field"
                  maxLength="1"
                  onKeyUp={(e) => moveField(e, "", "field5")}
                />
              </div>
              <Button type="submit" className="submit_btn glow neon">
                Verify
              </Button>
              <div className="form_group">
                <p>Resend OTP</p>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default OTP;
